export enum Page {
  Settings = '/settings',
  Account = '/account',
  AccountAdd = '/account/add',
  Accounts = '/account',

  Login = '/login',
  SignUp = '/sign-up',

  SpeechCommant = '/speech-commant',
  Schedule = '/schedule',
  Content = '/content',
  ContentTechnical = '/content-technical',
  RelationContent = '/relation-content',

  Patient = '/patient',
  PatientAdd = '/patient/add',
  Patients = '/patient',

  Events = '/events',
  Systemcheck = '/systemcheck',
}
